<template>
  <ContentContainer>
    <ClientOnly>
      <span
        v-if="anchorId"
        :id="anchorId"
        class="dynamic-anchor"
        :data-text="props.anchorName"
      />
    </ClientOnly>
  </ContentContainer>
</template>

<script setup lang="ts">
import { slugifyHeading } from '@/utils/tableOfContents';

const props = defineProps<{
  anchorName?: string;
}>();

const anchorId = computed(() => slugifyHeading(props.anchorName));
</script>
